import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../servants/section_swap_servant';
import { SwapTypeStrategy } from '../../strategies/swap_strategy';
import { ISectionSwapType } from '../../interfaces/swap_section_interface';

export class SwapPreviewBannerController {
  private section: ISection & ISectionSwapType;
  private isSwap: boolean = false;
  private showCheck: boolean = false;
  private bannerMessage: string;
  constructor(private ngSectionSwapServant: SectionSwapServant) {}

  $onChanges() {
    this.init();
  }

  init() {
    this.isSwap = !_4.isUndefined(this.section._swap_type) && this.ngSectionSwapServant.isInSwapMode();
    this.bannerMessage = SwapTypeStrategy[this.section._swap_type];
    this.showCheck = this.section._swap_type === 'to';
  }
}

angular.module('capability-ng-scheduler').component('swapPreviewBanner', {
  templateUrl: 'capability-ng-scheduler/src/swap/components/swap_preview_banner/swap_preview_banner.html',
  controller: SwapPreviewBannerController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/swap_preview_banner/swap_preview_banner.ts